"use client";
import {
  getInjectedConnector
} from "./chunk-WXICAEA2.js";

// src/wallets/walletConnectors/injectedWallet/injectedWallet.ts
var injectedWallet = () => ({
  id: "injected",
  name: "Browser Wallet",
  iconUrl: async () => (await import("./injectedWallet-AWJSZPMG.js")).default,
  iconBackground: "#fff",
  createConnector: getInjectedConnector({})
});

export {
  injectedWallet
};
